/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Scanning_ToastInputs */



/**
* | output |
* | --- |
* | "Scanning media for shot changes" |
*
* @param {Scene_Change_Detection_Scanning_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_scanning_toast = /** @type {((inputs?: Scene_Change_Detection_Scanning_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Scanning_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Analyse du media pour les changements de plan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medien nach Szenenwechseln durchsuchen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scansione dei supporti per modifiche di ripresa")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сканирование медиафайлов для смены кадров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Escaneo de medios para cambios de toma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("扫描介质以进行镜头切换")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショットの変更点をメディアでスキャンする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट में बदलाव के लिए मीडिया को स्कैन करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Analisando a mídia em busca de alterações de planos")
	return /** @type {LocalizedString} */ ("Scanning media for shot changes")
});